// Инициализация главного меню

/**
 * Инициализация главного меню
 */
function main(): void
{
	const panel = document.querySelector( 'body>nav.main' ) as HTMLElement;
	const menuList = panel.querySelector( 'ul.menu' ) as HTMLElement;
	
	if ( !panel || !menuList )
	{
		return;
	}
	
	panel.addEventListener(
		'click',
		( event ) =>
		{
			if (
				( (event.target as HTMLElement).tagName === 'A' )
				|| !menuList.contains( event.target as Node )
			)
			{
				panel.classList.toggle( 'open' );
			}
		},
	);
	
	if ( window.location.pathname === '/' )
	{
		return;
	}
	
	const logo = panel.querySelector( 'div.logo' );
	
	if ( !logo )
	{
		return;
	}
	
	logo.classList.add( 'clickable' );
	logo.addEventListener(
		'click',
		( event ) =>
		{
			if ( !panel.classList.contains( 'open' ) )
			{
				return;
			}
			
			event.stopPropagation();
			window.location.href = '/';
		},
	);
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/MainMenu/index.ts